import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, TrendingUp, Trophy, BarChart3, X } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Home', icon: Home, to: '/' },
  { label: 'Predictions', icon: TrendingUp, to: '/predictions' },
  { label: 'Leaderboard', icon: Trophy, to: '/leaderboard' },
  { label: 'Symbols', icon: BarChart3, to: '/symbols' },
];

export default function PublicSidebar({ isOpen, onClose }) {
  const { pathname } = useLocation();

  return (
    <aside className={`
      fixed inset-y-0 left-0 z-50 w-64 flex flex-col py-6 bg-white border-r border-gray-100 shadow-sm overflow-y-auto
      transition-transform duration-300 ease-in-out
      ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      md:relative md:translate-x-0 md:z-auto md:flex-shrink-0 md:h-screen
    `}>
      {/* Brand */}
      <div className="px-8 mb-8 flex items-start justify-between">
        <div>
          <h1 className="font-black text-gray-900 text-xl tracking-tight">TraderBro</h1>
          <p className="text-gray-400 text-[10px] uppercase tracking-widest mt-1">
            Finfluencer Accountability, Quantified.
          </p>
        </div>
        <button
          onClick={onClose}
          className="md:hidden text-gray-400 hover:text-gray-700 transition-colors mt-1 -mr-2 p-1"
          aria-label="Close menu"
        >
          <X size={18} />
        </button>
      </div>

      {/* Nav */}
      <div className="space-y-0.5 flex-1">
        <nav>
          {NAV_ITEMS.map(({ label, icon: Icon, to }) => {
            const isActive = pathname === to;
            return (
              <Link
                key={to}
                to={to}
                onClick={onClose}
                className={`group flex items-center px-8 py-2.5 text-sm font-medium transition-all ${
                  isActive
                    ? 'text-emerald-600 border-l-2 border-emerald-500 bg-emerald-50/60'
                    : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
                }`}
              >
                <Icon size={18} className="mr-3 flex-shrink-0" />
                {label}
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Bottom: Sign In / Sign Up */}
      <div className="px-6 pt-4 mt-auto border-t border-gray-100 flex flex-col gap-2">
        <Link
          to="/login"
          className="block w-full py-2.5 text-center bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl font-bold text-sm transition-colors active:scale-95"
        >
          Sign In
        </Link>
        <Link
          to="/login"
          className="block w-full py-2.5 text-center bg-white text-gray-700 border border-gray-200 rounded-xl font-semibold text-sm hover:border-gray-400 hover:text-gray-900 active:scale-95 transition-all"
        >
          Sign Up
        </Link>
      </div>
    </aside>
  );
}
